export default __webpack_public_path__ + "static/media/M1A_5.9fcd64fb.png";